// extracted by mini-css-extract-plugin
module.exports = {"rangeWrapper":"Range_rangeWrapper__1L-HC","range":"Range_range__1EtOi","focused":"Range_focused__2Tel3","limitsWrapper":"Range_limitsWrapper__1skxA bodySDefault"};